<ng-container *ngIf="{ invoices: invoices$ | async, billings: billings$ | async } as vm">
  <ion-header class="ion-no-border">
    <ion-toolbar>
      <ion-title>Facturación</ion-title>
      <ion-buttons slot="start">
        <ion-back-button defaultHref="/tecservice-transportec/profile" color="primary"></ion-back-button>
      </ion-buttons>
      <ion-buttons slot="end" *ngIf="show === 'info'">
        <ion-button (click)="addBillingInfo()">
          <ion-icon slot="icon-only" name="add"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
    <ion-toolbar>
      <ion-segment mode="md" [(ngModel)]="show">
        <ion-segment-button value="invoices">
          <ion-label>Facturas</ion-label>
        </ion-segment-button>
        <ion-segment-button value="info">
          <ion-label>Datos</ion-label>
        </ion-segment-button>
      </ion-segment>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <ion-refresher (ionRefresh)="doRefresh($event)" slot="fixed" #ionRefresher>
      <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <div *ngIf="show === 'invoices'">
      <ion-list lines="none" *ngIf="!vm.invoices?.data && loadingInvoices">
        <ion-item *ngFor="let invoice of [0, 1, 2, 3, 4]">
          <ion-row>
            <ion-col size="12">
              <h4>
                <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
              </h4>
              <p class="date">
                <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
              </p>
            </ion-col>
          </ion-row>
        </ion-item>
      </ion-list>
      <ion-list lines="none">
        <ion-item *ngIf="vm.invoices?.data?.length === 0 && !loadingInvoices">
          <ion-label>
            <h2>No tienes facturas.</h2>
          </ion-label>
        </ion-item>
        <ion-item *ngFor="let transaction of vm.invoices?.data">
          <ion-label>
            <ion-row>
              <ion-col size="12">
                <h2>{{ transaction.title }}</h2>
                <p>{{ transaction.amount | currency: 'USD':'symbol':'1.0-0' }}</p>
                <p class="date">{{ transaction.created_at | date: 'dd/MM/yyyy' }}</p>
              </ion-col>
            </ion-row>
          </ion-label>
          <ion-button
            *ngIf="transaction.invoiced === null"
            color="primary"
            shape="round"
            (click)="selectBilling(transaction)"
            slot="end"
            mode="ios"
          >
            Facturar
          </ion-button>
          <ion-button
            *ngIf="transaction.invoiced === 0"
            color="light"
            shape="round"
            mode="ios"
            slot="end"
            [routerLink]="['/tecservice-transportec/wallet/tickets/']"
            [queryParams]="{ show: 'tickets' }"
          >
            Pendiente
          </ion-button>
          <ion-button
            *ngIf="transaction.invoiced"
            color="light"
            shape="round"
            mode="ios"
            slot="end"
            [routerLink]="['/tecservice-transportec/wallet/tickets/']"
            [queryParams]="{ show: 'tickets' }"
          >
            Facturado
          </ion-button>
          <!-- <div class="p-ultra" slot="end" *ngIf="invoice.invoiced">
            <b>
              <ion-icon name="document-attach-outline" (click)="download(transaction.invoice.pdf)"></ion-icon>
              <span>PDF</span>
            </b>
            <b>
              <ion-icon name="document-text-outline" (click)="download(transaction.invoice.xml)"></ion-icon>
              <span>XML</span>
            </b> 
            </div>
          -->
        </ion-item>
      </ion-list>
    </div>
    <div *ngIf="show === 'info'">
      <ion-list lines="none" *ngIf="!vm.billings?.data && loadingBillings">
        <ion-item *ngFor="let invoice of [0, 1, 2, 3, 4]">
          <ion-row>
            <ion-col size="12">
              <h4>
                <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
              </h4>
              <p class="date">
                <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
              </p>
            </ion-col>
          </ion-row>
        </ion-item>
      </ion-list>
      <ion-list lines="none">
        <ion-item *ngIf="vm.billings?.data?.length === 0 && !loadingBillings">
          <ion-label>
            <h2>No tienes datos de facturación.</h2>
          </ion-label>
        </ion-item>
        <ion-item *ngFor="let item of vm.billings?.data">
          <ion-label>
            <ion-row>
              <ion-col size="12">
                <h2>{{ item.name }}</h2>
                <p>{{ item.rfc }}</p>
              </ion-col>
            </ion-row>
          </ion-label>
          <div class="p-ultra" slot="end">
            <b>
              <ion-icon name="create-outline" (click)="addBillingInfo(item)"></ion-icon>
            </b>
            <b>
              <ion-icon name="trash-outline" (click)="deleteBillingInfo(item)"></ion-icon>
            </b>
          </div>
        </ion-item>
      </ion-list>
    </div>
    <ion-infinite-scroll
      (ionInfinite)="this.show === 'invoices' ? doInfinite($event, vm.invoices!) : doInfinite($event, vm.billings!)"
    >
      <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Cargando..."></ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </ion-content>
</ng-container>
